import '@formatjs/intl-pluralrules/polyfill';
import smoothscroll from 'smoothscroll-polyfill';
import 'intersection-observer';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import '@babel/polyfill';
import { unregister } from './registerServiceWorker';
import { configureStore } from './core/store';
import rootReducer from './reducers';
import App from './app';

smoothscroll.polyfill();
const store = configureStore(rootReducer);

const root = document.getElementById('rootSSR'); // root 改為 rootSSR

// see #1373
if (!root.hasChildNodes()) {
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    root,
  );
}
unregister();
